import React from "react"
import { compose, withProps } from "recompose"
import { withScriptjs, withGoogleMap, GoogleMap, Marker, Polygon } from "react-google-maps"
import '../css/GM.css'
import kav_yarok from "../data/kav_yarok.json"

function latRad(lat) {
    var sin = Math.sin(lat * Math.PI / 180);
    var radX2 = Math.log((1 + sin) / (1 - sin)) / 2;
    return Math.max(Math.min(radX2, Math.PI), -Math.PI) / 2;
}

function zoom(mapPx, worldPx, fraction) {
    return Math.floor(Math.log(mapPx / worldPx / fraction) / Math.LN2);
}

function getBoundsZoomLevel(bounds, mapDim) {
    var WORLD_DIM = { height: 256, width: 256 };
    var ZOOM_MAX = 21;
    var ne = { lat: bounds["north"], lng: bounds["east"] };
    var sw = { lat: bounds["south"], lng: bounds["west"] };
    var latFraction = (latRad(ne["lat"]) - latRad(sw["lat"])) / Math.PI;
    var lngDiff = ne["lng"] - sw["lng"];
    var lngFraction = ((lngDiff < 0) ? (lngDiff + 360) : lngDiff) / 360;
    var latZoom = zoom(mapDim.height, WORLD_DIM.height, latFraction);
    var lngZoom = zoom(mapDim.width, WORLD_DIM.width, lngFraction);
    return Math.min(latZoom, lngZoom, ZOOM_MAX);
}


const MyMapComponent = compose(
    withProps({
        googleMapURL: "https://maps.googleapis.com/maps/api/js?key=AIzaSyC3Zs8ssRZ9taT2Z7vO0VEtenheIneqHzs&v=3.exp&libraries=geometry,drawing,places",
        loadingElement: <div style={{ height: '100%' }} />,
        containerElement: <div class="MapContainer" />,
        mapElement: <div class="Map" />,
    }),
    withScriptjs,
    withGoogleMap
)((props) =>
    <GoogleMap
        className="Map"
        zoom={getBoundsZoomLevel(props.bounds, { height: 450, width: 850 })}
        center={{ lat: props.center["lat"], lng: props.center["lng"] }}
        options={{ streetViewControl: false, mapTypeControl: false }}
        clickableIcons={false}
    >
        {
            props.markersToRender.map((kalpi) => {
                let marker = <Marker
                    position={{ lat: kalpi["lat"], lng: kalpi["lng"] }}
                    title={kalpi["address"] + ", " + kalpi["votes"] + " קולות"}
                    visible={props.show["kalpies"]}
                    icon={{
                        url: "http://maps.google.com/mapfiles/kml/pal4/icon25.png"
                    }}
                />;
                return marker;
            })
        }
        {
            props.clustersToRender.map((cluster) => {
                let marker = <Marker
                    position={{ lat: cluster["real_centroid"]["lat"], lng: cluster["real_centroid"]["lng"] }}
                    label={{
                        text: cluster["cluster_num"].toString(),
                        fontSize: "6"
                    }}
                    icon={{
                        url: "https://maps.google.com/mapfiles/ms/icons/lightblue.png",
                        labelOrigin: { x: 16, y: 9 }
                    }}

                    title={cluster["votes"] + " קולות "}
                    visible={props.show["numbers"]}
                    labelInBackground="false"
                />;
                return marker;
            })
        }
        {
            props.clustersToRender.map((cluster) => {
                let poly = <Polygon
                    paths={[cluster["polygon_pts"][0], cluster["polygon_pts"][1]]}
                    visible={props.show["polygons"]}
                    zIndex={5}
                    options={{
                        strokeWeight: "2",
                        strokeColor: cluster["color"],
                        fillColor: cluster["color"],
                        fillOpacity: "0.3"
                    }}
                ></Polygon>;
                return poly;
            })
        }
        {props.clustersToRender.length === 120 &&
            <Polygon
                paths={[kav_yarok["polygon_pts"]]}
                visible={props.show["polygons"]}
                options={{
                    strokeWeight: "2",
                    strokeColor: "green",
                    fillColor: "green",
                    fillOpacity: "0.2"
                }}
            ></Polygon>
        }
    </GoogleMap >
)

class GM extends React.PureComponent {
    render() {
        return (
            <MyMapComponent
                key={this.props.showPolicy}
                markersToRender={this.props.markersToRender}
                clustersToRender={this.props.clustersToRender}
                center={this.props.center}
                bounds={this.props.bounds}
                show={this.props.showPolicy}
            />
        )
    }
}

export default GM;